import React from 'react';
import { Button } from '@heroui/react';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

interface CoursesErrorStateProps {
  error: string;
  onRetry: () => void;
}

const CoursesErrorState: React.FC<CoursesErrorStateProps> = ({ error, onRetry }) => {
  const { t } = useTranslation('courses');
  return (
    <div className="mb-8 bg-red-50 dark:bg-red-950/30 border-l-4 border-red-500 rounded-xl p-6 flex items-start gap-4 shadow-lg backdrop-blur-sm">
      <div className="flex-shrink-0 p-2 rounded-lg bg-red-100 dark:bg-red-900/50">
        <AlertCircle className="w-5 h-5 text-red-600 dark:text-red-400" />
      </div>
      <div className="flex-1">
        <h3 className="font-bold text-red-900 dark:text-red-200 mb-1">{t('states.error.title')}</h3>
        <p className="text-sm text-red-700 dark:text-red-300 mb-4">{error || t('states.error.message')}</p>
        <Button color="danger" variant="flat" onPress={onRetry}>
          {t('states.error.retry')}
        </Button>
      </div>
    </div>
  );
};

export default CoursesErrorState;

